import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../../../Redux";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import ModelContainer from "../../../Components/ModelContainer";

import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import ErrorContainer from "../../../Components/ErrorContainer";
import Input from "../../../Components/Input";

const ApiKeyListing = () => {
  const dispatch = useDispatch();
  const apiKeys = useSelector(
    (state) => state?.settingReducer?.apiKeyList?.api_keys
  );
  useEffect(() => {
    dispatch(actions?.getApiKeyListing());
  }, []);
  const confirmPassModalState = useSelector(
    (state) => state?.settingReducer?.confirm_pass_modal
  );
  const setConfirmPassModalState = (state) =>
    dispatch(
      actions.setModalState({
        modalName: "confirm_pass_modal",
        modalState: state,
      })
    );

  const generateKeyModalState = useSelector(
    (state) => state?.settingReducer?.generate_api_key_modal
  );
  const setGenerateKeyModalState = (state) =>
    dispatch(
      actions.setModalState({
        modalName: "generate_api_key_modal",
        modalState: state,
      })
    );
  const [secretKey, setSecretKey] = useState("");
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="row employeeSettingSec d-flex">
          <div className="col-md-12">
            <div className="shadowclass d-flex flex-wrap align-content-start">
              <h4 className="event-alert w-100">API Keys</h4>

              <div class="table-responsive">
                <table class="checklist-table remove-space inventory_table">
                  <thead>
                    <tr>
                      <th class="first-col col-2">S.N.</th>
                      <th className="col-2">Key Name</th>
                      <th>Integration Partner</th>
                      <th>API Key</th>
                      <th>Secret Key</th>
                      <th> Actions </th>
                    </tr>
                  </thead>
                  <tbody>
                    {apiKeys?.map((el, idx) => (
                      <tr>
                        <td>{idx + 1} </td>
                        <td>{el?.key_name}</td>
                        <td>{el?.integration_partner}</td>
                        <td>{el?.api_key}</td>
                        <td>
                          <p
                            onClick={() => {
                              setConfirmPassModalState(true);
                              setSecretKey(el?.secret_key);
                            }}
                            class=" circle_icon"
                          >
                            <i class="iconSprites eye-icon"></i>
                          </p>
                        </td>
                        <td>
                          <p
                            onClick={() => {
                              dispatch(
                                actions?.postDeleteApiKey({ id: el?.id })
                              );
                            }}
                            class="deleteCount circle_icon red"
                          >
                            <i class="iconSprites delete-icon"></i>
                          </p>
                        </td>
                      </tr>
                    ))}{" "}
                  </tbody>
                </table>
                {/* <div class="my-3">
                  <button
                    onClick={() => {
                      setShowModal(true);
                      setModalType("add");
                    }}
                    class="btn green-btn-revert add-plus"
                    id="addCount"
                    type="button"
                  >
                    <i class="i-icon"> </i> Add Count
                  </button>
                </div> */}
              </div>
              <div class="row-fluid">
                <div class="merchant-row btns span2 text-left ml-0">
                  <div class="field">
                    <button
                      onClick={() => {
                        setGenerateKeyModalState(true);
                      }}
                      class="ml-0 btn green-btn-revert generateApiKey"
                      type="button"
                    >
                      {" "}
                      Generate API Key{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ConfirmPassword
          confirmPassModalState={confirmPassModalState}
          setConfirmPassModalState={setConfirmPassModalState}
          secretKey={secretKey}
          setSecretKey={setSecretKey}
        />
        <GenerateApiKey
          generateKeyModalState={generateKeyModalState}
          setGenerateKeyModalState={setGenerateKeyModalState}
        />
      </div>
    </UserInterface>
  );
};

const ConfirmPassword = ({
  confirmPassModalState,
  setConfirmPassModalState,
  secretKey,
  setSecretKey,
}) => {
  const confirmPassStatus = useSelector(
    (state) => state?.settingReducer?.confirmPasswordStatus
  );
  const dispatch = useDispatch();
  const [pass, setPass] = useState("");
  return (
    <ModelContainer
      title={confirmPassStatus ? "View Secret Key" : "Confirm your password"}
      open={confirmPassModalState}
      closeModal={() => {
        dispatch(actions?.saveConfirmPasswordStatus(false));
        setConfirmPassModalState(!confirmPassModalState);
        setSecretKey("");
      }}
      submitModal={
        confirmPassStatus
          ? false
          : () => {
              dispatch(actions?.postConfirmPassword({ password: pass }));
            }
      }
    >
      {confirmPassStatus ? (
        <ul>
          <li>
            <div class="mb10 vir-sec-key">
              <h6 class="secret_key_text">{secretKey}</h6>
              <button
                onClick={() => {
                  navigator.clipboard.writeText(secretKey);
                }}
                class="copyText"
                type="button"
              >
                {" "}
                <span class="tooltip"> Copy Key </span>{" "}
              </button>
            </div>
          </li>
        </ul>
      ) : (
        <form>
          <ul className="form-list label-group">
            <li>
              <label className={"required"}>{"Password"}</label>
              <div class={`input-group`}>
                <input
                  type={"password"}
                  onChange={(e) => {
                    setPass(e.target.value);
                  }}
                />
              </div>
            </li>
          </ul>
        </form>
      )}
    </ModelContainer>
  );
};
const GenerateApiKey = ({
  generateKeyModalState,
  setGenerateKeyModalState,
}) => {
  const confirmPassStatus = useSelector(
    (state) => state?.settingReducer?.confirmPasswordStatus
  );
  const dispatch = useDispatch();
  const [pass, setPass] = useState("");

  const addDefaultState = {
    key_name: "",
    integration_partner: "",
  };

  const schema = yup.object({
    key_name: yup.string().required(),
    integration_partner: yup.string().required(),
  });

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: addDefaultState,
  });

  function submitData(data) {
    dispatch(actions?.postGenerateApikey(data));
  }
  return (
    <ModelContainer
      title={confirmPassStatus ? "Enter the Details" : "Confirm your password"}
      open={generateKeyModalState}
      closeModal={() => {
        dispatch(actions?.saveConfirmPasswordStatus(false));
        setGenerateKeyModalState(!generateKeyModalState);
      }}
      submitModal={
        confirmPassStatus
          ? handleSubmit(submitData)
          : () => {
              dispatch(actions?.postConfirmPassword({ password: pass }));
            }
      }
    >
      {confirmPassStatus ? (
        <form>
          <ul className="form-list label-group">
            <Input
              label={"Key Name"}
              formRegister={register}
              formError={errors}
              formKey={"key_name"}
            />
            <Input
              label={"Integration Parter"}
              formRegister={register}
              formError={errors}
              formKey={"integration_partner"}
            />
          </ul>
        </form>
      ) : (
        <form>
          <ul className="form-list label-group">
            <li>
              <label className={"required"}>{"Password"}</label>
              <div class={`input-group`}>
                <input
                  type={"password"}
                  onChange={(e) => {
                    setPass(e.target.value);
                  }}
                />
              </div>
            </li>
          </ul>
        </form>
      )}
    </ModelContainer>
  );
};
export default ApiKeyListing;
